export const release = "03-NOV-26 13:11:45";
export const lemmonEnv: any = (globalThis as any).lemmonEnv;
